<span [style.color]="color()">
  {{ text() }}
</span>
